import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../components/Modal";
import { Text } from "../../../styles/Common";
import { theme } from "../../../styles/theme";
import { Button } from "../../../components/Button";
import { AlertIcon } from "../../../assets/icons";

const ModalWarningSurvey = ({ showModal, handleCloseModal, isMobile, description }) => {
    
  return (
    <Modal
      open={showModal}
      onCancel={handleCloseModal}
      padding={!isMobile ? "29px 63px 37px 63px" : "29px 25px 37px 25px"}
      width={!isMobile ? "611px" : "100%"}
      height={"auto"}
    >
      <Modal.Header
        title={"¡Espera un momento!"}
        sizeTitle={theme.fonts.size.h1}
        colorTitle={theme.colors.blue500}
        weightTitle={theme.fonts.weight.bold}
        margin={"0 0 22px 0"}
        icon={<AlertIcon stroke={theme.colors.red} />}
        iconBackground={theme.colors.white50}
        iconBorderColor={theme.colors.red}
      />
      <Modal.Body>

        <Text
        size={theme.fonts.size.h6}
        color={theme.colors.gray200}
        weight={theme.fonts.weight.semibold}
        mb="20px"
        >
            {description}
        </Text>

        <Button width={!isMobile ? "297px" : "230px"} onClick={handleCloseModal}>
          Continuar
        </Button>
      </Modal.Body>
    </Modal>
  );
};
ModalWarningSurvey.propTypes = {
  showModal: PropTypes.bool,
  isMobile: PropTypes.isMobile,
  handleCloseModal: PropTypes.func,
  description: PropTypes.string
};
export default ModalWarningSurvey;
